import { Typography, Card, CardContent, Box, Button } from '@mui/material';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { useState } from 'react';
import EditBox from './EditBox';
import { variants } from '../../../../variants/variants';

export const ShowMore = ({ items, sliceCount, designation, title, handleDisableChange }) => {
  const [show, setShow] = useState(false);
  const handleShowAll = () => {
    setShow(prev => !prev);
  };
  return (
    <Card sx={{ borderRadius: '10px', boxShadow: 'none', border: 1, borderColor: 'divider', flex: 1 }}>
      <CardContent>
        <Typography sx={{ fontSize: variants.BODY, fontWeight: 600, textAlign: 'center' }}>{title}</Typography>
        {(show ? items : items.slice(0, sliceCount)).map((item, index) => (
          <EditBox
            designation={designation}
            question={item}
            index={index}
            key={index}
            title={title}
            handleDisableChange={handleDisableChange}
          />
        ))}
      </CardContent>
      {items.length > sliceCount && (
        <Box sx={{ display: 'flex', justifyContent: 'center', borderTop: '1px solid lightgrey' }}>
          <Button fullWidth onClick={handleShowAll} endIcon={<ArrowForwardIcon />} sx={{ fontWeight: 'bold' }}>
            {show ? `Hide All Questions` : `Show All ${items.length} Questions`}
          </Button>
        </Box>
      )}
    </Card>
  );
};
